<script setup>
import { ref, onMounted } from 'vue';
import AppCard from './layouts/AppCard.vue';

const areaImageMap = {
    'Socio-emotional Development': '/demo_socioemotional.webp',
    'Motor and Physical Development': '/demo_motor.jpeg',
    'Language and Communication Development': '/demo_language.jpeg',
    'Cognitive Development': '/demo_cognitive.jpeg',
}

const imageUrl = ref('')

onMounted(() => {
    imageUrl.value = areaImageMap[props.title]
})


const props = defineProps({
    milestoneId: Number,
    title: String,
    shortDescription: String,
    longDescription: String,
    primaryImage: Object,
    reverse: Boolean,
})

const scrollTo = () => {
    const container = document.getElementById(`milestone-${props.milestoneId}-details`)
    container.scrollIntoView({ behavior: 'smooth' })
}

</script>
<template>
    <AppCard :header="props.title" :body="props.shortDescription" >
        <button type="button" @click="scrollTo()"
            class="focus:outline-none text-white bg-accent border-teal-500 border-2 hover:bg-teal-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm md:px-5 py-2.5 md:mr-2 md:mb-2 p-4">Jump to Section</button>
    </AppCard>
</template>